import * as React from "react";
import { Route, RouteProps } from "react-router-dom";
// @ts-ignore - jwt-decode v2 doesn't have types
import jwt_decode from "jwt-decode";
// @ts-ignore - BROWSER_CONSTANTS types not yet migrated
import { BROWSER_CONSTANTS } from "@constants";
import SelectAuthAllView from "@features/select-clients/selectAuth-all-view";
import type { JWTPayload } from "@types";

interface ProtectedRouteProps extends Omit<RouteProps, "component"> {
  component: React.ComponentType<any>;
  oneStepAuth?: boolean;
  twoStepAuth?: boolean;
  zeroStepAuth?: boolean;
  searchParams?: string;
}

type AuthStep = "JWTAndCTID" | "JWTOnly" | "zeroAuth" | "NONE";

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component: Component,
  oneStepAuth,
  twoStepAuth,
  zeroStepAuth,
  ...rest
}) => {
  const authenticateRoute = (step: AuthStep): boolean => {
    const searchParams = new URLSearchParams(location.search);
    const JWT_TOKEN =
      localStorage.getItem(BROWSER_CONSTANTS.JWT_TOKEN) ||
      searchParams.get(BROWSER_CONSTANTS.JWT_TOKEN) ||
      "";
    let decoded_jwt: JWTPayload | null = null;
    
    try {
      decoded_jwt = JWT_TOKEN ? jwt_decode<JWTPayload>(JWT_TOKEN) : null;
    } catch (error) {
      console.warn("Failed to decode JWT token", error);
      return false;
    }

    let authenticated = false;
    
    switch (step) {
      case "JWTAndCTID":
        const ctid = localStorage.getItem("ctid") || "";
        authenticated =
          (decoded_jwt &&
            !!decoded_jwt?.username &&
            decoded_jwt?.ctid?.toString() === ctid) ||
          false;
        break;
      case "JWTOnly":
        authenticated = (decoded_jwt && !!decoded_jwt?.username) || false;
        break;
      case "zeroAuth":
        authenticated = true;
        break;
      default:
        authenticated = false;
        break;
    }
    return authenticated;
  };

  const redirect = (): JSX.Element => {
    sessionStorage.clear();
    localStorage.clear();
    // @ts-ignore - SelectAuthAllView props compatibility
    return <SelectAuthAllView {...rest} />;
  };

  return (
    // @ts-ignore - React Router v5 type compatibility
    <Route
      {...rest}
      render={(props) => {
        const stepAuth: AuthStep = oneStepAuth
          ? "JWTOnly"
          : twoStepAuth
          ? "JWTAndCTID"
          : zeroStepAuth
          ? "zeroAuth"
          : "NONE";
        return authenticateRoute(stepAuth) ? (
          // @ts-ignore - ComponentType compatibility
          (<Component {...rest} {...props} />)
        ) : (
          redirect()
        );
      }}
    />
  );
};

export default ProtectedRoute;
